import { render, staticRenderFns } from "./TheAttachmentExpanded.vue?vue&type=template&id=883c4e18&"
import script from "./TheAttachmentExpanded.vue?vue&type=script&lang=js&"
export * from "./TheAttachmentExpanded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports